import React from 'react';
import { RacingsResultList } from './racingsResultList';
import { ResultFilter } from './resultFilter';

const RacingResultMain = ({ routePrefix = "" }) => {
  return <>
    <div className="racings-list-header">
      <ResultFilter />
    </div>
    <RacingsResultList routePrefix={routePrefix} />
  </>

};

export default RacingResultMain;
